"use strict";

exports.__esModule = true;
exports.defaultBreakpoints = exports.createMediaQuery = void 0;
exports.parseBreakpoints = parseBreakpoints;
exports.parseResponsiveObject = parseResponsiveObject;
exports.parseResponsiveStyle = parseResponsiveStyle;
exports.responsive = responsive;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const createMediaQuery = n => `@media screen and (min-width: ${n})`;

exports.createMediaQuery = createMediaQuery;
const defaultBreakpoints = ['600px', '1024px', '1280px', '1920px'];
exports.defaultBreakpoints = defaultBreakpoints;

function parseBreakpoints(breakpoints) {
  return breakpoints.map(item => createMediaQuery(item));
}

function parseResponsiveStyle(options) {
  const {
    cache,
    propValue,
    props,
    scale,
    systemConfig
  } = options;
  const mediaQueries = cache.get('mediaQueries');
  let styles = {};
  propValue.slice(0, mediaQueries.length).forEach((item, index) => {
    const media = mediaQueries[index];
    const value = typeof item === 'function' ? item(props.theme) : item;
    const style = systemConfig(value, scale, props);
    styles = !media ? { ...styles,
      ...style
    } : { ...styles,
      [media]: { ...styles[media],
        ...style
      }
    };
  });
  return styles;
}

function parseResponsiveObject(options) {
  const {
    cache,
    propValue,
    props,
    scale,
    systemConfig
  } = options;
  const breakpoints = cache.get('breakpoints');
  let styles = {};

  for (const key in propValue) {
    const breakpoint = breakpoints[key];
    const item = propValue[key];
    const value = typeof item === 'function' ? item(props.theme) : item;
    const style = systemConfig(value, scale, props);

    if (!breakpoint) {
      styles = { ...styles,
        ...style
      };
    } else {
      const media = createMediaQuery(breakpoint);
      styles = { ...styles,
        [media]: { ...styles[media],
          ...style
        }
      };
    }
  }

  return styles;
}

function responsive(styles) {
  return theme => {
    const result = {};
    const breakpoints = (0, _lodash.default)(theme, 'breakpoints', defaultBreakpoints);
    const mediaQueries = [null, ...parseBreakpoints(breakpoints)];

    for (const style in styles) {
      const styleValue = typeof styles[style] === 'function' ? styles[style](theme) : styles[style];
      if (styleValue === null) continue;

      if (!Array.isArray(styleValue)) {
        result[style] = styleValue;
        continue;
      }

      for (let i = 0; i < styleValue.slice(0, mediaQueries.length).length; i += 1) {
        const media = mediaQueries[i];

        if (!media) {
          result[style] = styleValue[i];
          continue;
        }

        result[media] = result[media] || {};
        if (styleValue[i] == null) continue;
        result[media][style] = styleValue[i];
      }
    }

    return result;
  };
}